import { css } from '@emotion/core';

export const fadeIn = () => css`
	animation: fadeIn 0.3s ease-in-out;

	@keyframes fadeIn {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
`;
